import { render } from "./MfFilePicker.vue?vue&type=template&id=33be0060&scoped=true"
import script from "./MfFilePicker.vue?vue&type=script&lang=js"
export * from "./MfFilePicker.vue?vue&type=script&lang=js"

import "./MfFilePicker.vue?vue&type=style&index=0&id=33be0060&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33be0060"]])

export default __exports__